import React, { Component } from 'react';
import { Chart } from "./common/Chart";
import ReactSpeedometer from "react-d3-speedometer";
import * as jsPDF from 'jspdf';
import 'es6-promise';
//import domtoimage from 'dom-to-image'
import html2canvas from 'html2canvas';
import { BrowserView, MobileView, isMobile, isIE } from "react-device-detect";
import Popup from 'reactjs-popup';
import { saveAs } from 'file-saver';
import { toBlob } from 'canvas-toBlob';

import './styles/AssessmentCharts.css';
import exportPdfIcon from '../images/save_pdf_icon.svg'

export class AssessmentCharts extends Component {
    handleNewAssessment = () => {
        this.props.handleReset(this.state)
    }

    //exportPdf = () => {
    //    var viewRecDocument = document.getElementById("AssessmentChartContainer")//this node gets saved as black background when saved as jpeg but not png
    //    domtoimage.toPng(viewRecDocument)
    //        // domtoimage.toSvg(node)
    //        .then(function (dataUrl) {
    //            var doc = new jsPDF()
    //            doc.addImage(dataUrl, 'a4', 11, 11, 190, 280)
    //            //doc.addPage();
    //            //doc.addImage(dataUrl, 'a4', 11, 262,190, 250)
    //            // doc.addImage(dataUrl,'a4',5,5,200,200)//for top node
    //            // doc.addSvg(dataUrl,1,1) 
    //            doc.viewerPreferences({
    //                'DisplayDocTitle ': true,
    //                'FitWindow ': true,
    //                'HideWindowUI': true,
    //            })
    //            doc.save('Assessment.pdf')
    //            //adds image to window document // for testing purposes
    //            //   var image = new Image()
    //            //   image.src = dataUrl
    //            //   document.body.appendChild(image);
    //        })
    //        .catch(function (error) {
    //            console.error('Exporting Pdf Caused an Error: ', error);
    //        });
    //}

    exportPdf = () => {
        var quotes = document.getElementById('AssessmentChartContainer');
        
        //if (isIE) {
        //    debugger;
        //}
        html2canvas(quotes)
            .then((canvas) => {
                let elwidth = canvas.width;
                let pageHeight = elwidth * 105 / 85;
                //var link = document.createElement('a');
                //if (typeof link.download === 'string') {
                //    link.href = canvas.toDataURL("image/jpeg");
                //    link.download = "assessment.jpg";
                //    //Firefox requires the link to be in the body
                //    document.body.appendChild(link);
                //    //simulate click
                //    link.click();
                //    //remove the link when done
                //    document.body.removeChild(link);
                //} else {
                //    window.open(canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream"));
                //}
                if (isMobile)
                    canvas.toBlob(function (blob) { saveAs(blob, "assessment.png") });
                else {
                    //! MAKE YOUR PDF
                    var pdf = new jsPDF('p', 'pt', 'letter');

                    for (var i = 0; i <= canvas.height / pageHeight; i++) {
                        //! This is all just html2canvas stuff
                        var srcImg = canvas;
                        var sX = 0;
                        var sY = pageHeight * i; // start 980 pixels down for every new page
                        var sWidth = elwidth;
                        var sHeight = pageHeight;
                        var dX = 0;
                        var dY = 0;
                        var dWidth = elwidth;
                        var dHeight = pageHeight;

                        var onePageCanvas = document.createElement("canvas");
                        onePageCanvas.setAttribute('width', elwidth);
                        onePageCanvas.setAttribute('height', pageHeight);
                        var ctx = onePageCanvas.getContext('2d');
                        // details on this usage of this function: 
                        // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
                        //ctx.scale(0.8, 0.8);
                        ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

                        // document.body.appendChild(canvas);
                        var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

                        var width = onePageCanvas.width;
                        var height = onePageCanvas.clientHeight;

                        //! If we're on anything other than the first page,
                        // add another page
                        if (i > 0) {
                            pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
                        }
                        //! now we declare that we're working on that page
                        pdf.setPage(i + 1);
                        //! now we add content to that page!
                        var wrate = 572 / elwidth;
                        var hrate = 711 / pageHeight;
                        pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width * wrate), (height * hrate));

                    }
                    //! after the for loop is finished running, we save the pdf.
                    pdf.save('Assessment.pdf');
                }
            });
    }
    pdfLink = () => {
        if (isMobile) {
            return (
                //<button className="btn btn-default Button_Save" onClick={this.exportPdf}>Save As Image</button>
                <Popup
                    trigger={<a className="PDFTooltip">How to save?</a>}
                    on="click"
                    position="bottom right"
                    closeOnDocumentClick>
                    <span>Your mobile has the ability to create a pdf of this page, and then you can save, email or print it.</span>
                </Popup>
            )
        }
        return (
            <Popup
                trigger={<img
                    src={exportPdfIcon}
                    onClick={this.exportPdf}
                    className="ExportPdfIcon"
                    alt="exportPdfIcon">
                </img>}
                on="hover"
                position="bottom right"
                closeOnDocumentClick
            >
                <span className="tooltip_content">For best results, please use Google Chrome, Firefox .etc. It doesn't work well on IE, Edge.</span>
            </Popup>
        )
    }
    render() {
        let resultStep = 0;
        let overallScore = 0;
        let indicatorNum = 0;
        let chartSection = (
            this.props.state.data.map((indicator, i) => {
                let arraysize = indicator.keyPerformanceIndicators.length;

                if (arraysize > 0) {
                    indicatorNum++;
                    let labelArray = [];
                    let dataArray = [];
                    let dotArray = [];
                    var score = 0;
                    var oscore = 0;
                    var idx = 0;

                    while (idx < arraysize) {
                        labelArray.push(indicator.keyPerformanceIndicators[idx].description);
                        dataArray.push(1);
                        resultStep++;
                        let resultValue = this.props.state.AssessmentResults[resultStep];
                        switch (resultValue) {
                            case "1":
                                score += 3;
                                oscore += 1;
                                dotArray.push(8);//this value is used to calculate the radius of the dot
                                break;
                            case "2":
                                score += 2
                                oscore += 2;
                                dotArray.push(2);
                                break;
                            case "3":
                                score += 1;
                                oscore += 3;
                                dotArray.push(1.1);
                                break;
                            default://incude the unselect options, score=0; the questions all are must choose now. so ignore this
                                //dotArray.push(1.1);
                                //oscore += 3.5;  //from Jason's excel, he set the unselected score = 3.5
                                break;
                        }
                        idx++;
                    }
                    //show fraction .1
                    score = Number(Math.round(100 * score / (arraysize * 3) + 'e1') + 'e-1');
                    //recalculate the overall score
                    oscore = oscore / arraysize;
                    if (oscore < 1.5) {
                        overallScore += 3;
                    }
                    else if (oscore < 2.5) {
                        overallScore += 2;
                    }
                    else if (oscore < 3.5) {
                        overallScore += 1;
                    }

                    //let n_score = score / 100;
                    return (
                        <div className="col-md-4 col-sm-6 align-items-center" key={i}>
                            <ReactSpeedometer
                                maxValue={100}
                                value={score}
                                needleColor="steelblue"
                                //startColor="red"
                                segments={3}
                                //endColor="green"
                                height={200}
                                currentValueText={`${indicator.description} ${score}%`}
                                needleTransitionDuration={4000}
                                needleTransition="easeElastic"
                            />
                        </div>
                    )
                }
            })
        )
        
        overallScore = overallScore / (indicatorNum * 3);
        let overallScorePentage = Number(Math.round(100 * overallScore + 'e1') + 'e-1');
        let overallChartSection = (
            <div className="col-xs-12 align-items-center">
                <ReactSpeedometer
                    maxValue={100}
                    value={overallScorePentage}
                    needleColor="steelblue"
                    //startColor="red"
                    segments={3}
                    //endColor="green"
                    width={340}
                    height={230}
                    currentValueText={`${overallScorePentage}%`}
                    needleTransitionDuration={4000}
                    needleTransition="easeElastic"
                />
            </div>
        )
        let step = 0;
        let TableContent = (
            this.props.state.data.map((indicator, i) => {
                return (
                    indicator.keyPerformanceIndicators.map((keyperformance, j) => {
                        step++;
                        let resultValue = this.props.state.AssessmentResults[step];
                        var linkUrl = this.props.state.IndustryData[this.props.state.IndustryId - 1].localUrl;
                        switch (resultValue) {
                            case "1":
                                return (
                                    <tr key={`${i}_${j}`}>
                                        <td>{indicator.description}</td>
                                        <td>{keyperformance.description}</td>
                                        <td className="GreenBG">{keyperformance.exceedingGoal}</td>
                                        <td><a href={`${linkUrl}${keyperformance.link}`} target="_blank">More info.</a></td>
                                    </tr>
                                )
                                break;
                            case "2":
                                return (
                                    <tr key={`${i}_${j}`}>
                                        <td>{indicator.description}</td>
                                        <td>{keyperformance.description}</td>
                                        <td className="YellowBG">{keyperformance.mettingGoal}</td>
                                        <td><a href={`${linkUrl}${keyperformance.link}`} target="_blank">More info.</a></td>
                                    </tr>
                                )
                                break;
                            case "3":
                                return (
                                    <tr key={`${i}_${j}`}>
                                        <td>{indicator.description}</td>
                                        <td>{keyperformance.description}</td>
                                        <td className="RedBG">{keyperformance.notArchievingGoal}</td>
                                        <td><a href={`${linkUrl}${keyperformance.link}`} target="_blank">More info.</a></td>
                                    </tr>
                                )
                                break;
                            default:
                                return (
                                    <tr key={`${i}_${j}`}>
                                        <td>{indicator.description}</td>
                                        <td>{keyperformance.description}</td>
                                        <td></td>
                                        <td><a href={`${linkUrl}${keyperformance.link}`} target="_blank">More info.</a></td>
                                    </tr>
                                )
                                break;
                        }
                    })
                )
            })
        )
        let AssessmentTable = (
            <div className="col-xs-12">
                <table className="table table-striped condensed">
                    <tbody>
                        <tr key="table-header">
                            <th>High Priority Indicator</th>
                            <th>Metric/KPI</th>
                            <th>Your Selection</th>
                            <th className="fixedcolumn">URL</th>
                        </tr>
                        {TableContent}
                    </tbody>
                </table>
            </div>
        )
        let buttonSection = (
            <div className="col-sm-12">
                <button className="form-control btn btn-primary button_start"
                    onClick={this.handleNewAssessment}
                    type="button"
                    aria-label="save">
                    <span>Take Another Assessment</span>
                </button>
            </div>)

        return (
            <React.Fragment >
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <span className="main-header"><i className="glyphicon glyphicon-list"></i>Results</span>
                        {/*<a className="pull-right main-header-button" onClick={this.exportPdf}><img src={exportPdfIcon} alt="exportPdfIcon"></img>Save As PDF</a>*/}
                        <div className="pull-right">
                            {this.pdfLink()}
                        </div>
                    </div>
                    <div className="panel-body score-panel" id="AssessmentChartContainer">
                        <div className="row">
                            <div className="col-xs-4">
                                <label>Industry: {this.props.state.IndustryData[this.props.state.IndustryId - 1].description}</label>
                            </div>
                            <div className="col-xs-4">
                                <label>Name: {this.props.state.Name}</label>
                            </div>
                            <div className="col-xs-4">
                                <label>Ranch: {this.props.state.Ranch}</label>
                            </div>
                            <div className="col-xs-4">
                                <label>State: {this.props.state.State}</label>
                            </div>
                            <div className="col-xs-4">
                                <label>Address: {this.props.state.Address}</label>
                            </div>
                            <div className="col-xs-4">
                                <label>Date: {this.props.state.Date}</label>
                            </div>
                        </div>
                        <div className="row vertical-center-row" >
                            <div className="col-xs-12">
                                <label className="chart-title">Overall Results</label>
                            </div>
                            {overallChartSection}
                            <div className="col-xs-12">
                                <label className="chart-title">Result for High Priority Indicators</label>
                            </div>
                            {chartSection}
                            {AssessmentTable}
                            {buttonSection}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AssessmentCharts.js